/** §4.3, from the beheerder's side: correcting what an ondersteuner passed on, namens hen. */
export const beschikbaarheid = {
  legend: "Wedstrijddagen",
  dagRegel: "{{niveau}} · {{korps}}",
  opslaan: "Beschikbaarheid opslaan",
  opgeslagen: "Opgeslagen.",
  geenDagen: "Aan deze inschrijfperiode hangen nog geen wedstrijddagen.",
  klassenLegend: "Gewenste klassen (optioneel)",
  errors: {
    periodesOphalen: "Kon de inschrijfperiodes niet ophalen.",
    ophalen: "Kon de beschikbaarheid niet ophalen.",
    opslaan: "Kon de beschikbaarheid niet opslaan.",
  },
} as const;
